const getCircleSize = () => {
  let vp = document.createElement("div");

  vp.style.width = "100vw";
  vp.style.height = "100vh";
  vp.style.position = "absolute";
  vp.style.top = 0;
  vp.style.left = 0;
  vp.style.pointerEvents = "none";

  document.body.appendChild(vp);

  let w = vp.offsetWidth,
    h = vp.offsetHeight,
    d = parseInt(Math.sqrt(w * w + h * h) + 1),
    dr = (d / 32).toFixed(2);

  document.body.removeChild(vp);
  document.documentElement.style.setProperty("--vpdr", "".concat(dr));
}

const midnightScreenTest = (e) => {
    if (e.matches) {
      $('.nav-main').midnight()
    } else {
      $('.nav-mobile').midnight()
      $('.burger-wrapper').midnight()
    }
  }

export {
    getCircleSize,
    midnightScreenTest
}
